import { useEffect, useState } from "react";
import axios from "axios";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { BellRing, Loader2, Plus, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/notification-recipients`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

// Admin addresses copied on announcement emails and day-before event reminders
export const NotifyRecipientsCard = () => {
  const [emails, setEmails] = useState(null);
  const [draft, setDraft] = useState("");
  const [saving, setSaving] = useState(false);
  useEffect(() => { axios.get(API, auth()).then((r) => setEmails(r.data.emails)).catch(() => setEmails([])); }, []);
  const save = async (list) => {
    setSaving(true);
    try { setEmails((await axios.put(API, { emails: list }, auth())).data.emails); toast.success("Recipients saved"); }
    catch (e) { toast.error(e.response?.data?.detail || "Save failed"); } finally { setSaving(false); }
  };
  const add = (e) => { e.preventDefault(); if (draft.trim()) { save([...emails, draft.trim()]); setDraft(""); } };
  if (!emails) return null;
  return (
    <Card className="border-slate-200" data-testid="notify-recipients-card">
      <CardContent className="p-5 space-y-3">
        <div>
          <h3 className="font-heading font-semibold text-navy flex items-center gap-2"><BellRing className="w-4 h-4 text-teal" />Admin notification recipients</h3>
          <p className="text-sm text-slate-500">These addresses get a copy of announcements emailed to dealers, plus the 9 AM reminder the day before every store event, with the flyer attached.</p>
        </div>
        <div className="flex flex-wrap gap-2" data-testid="notify-recipients-list">
          {emails.length === 0 && <span className="text-sm text-slate-400">No one added yet.</span>}
          {emails.map((e) => (
            <span key={e} className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-3 py-1 text-sm text-slate-700" data-testid={`notify-recipient-${e}`}>
              {e}<button type="button" onClick={() => save(emails.filter((x) => x !== e))} className="text-slate-400 hover:text-red-600" aria-label={`Remove ${e}`} data-testid={`notify-recipient-remove-${e}`}><X className="w-3.5 h-3.5" /></button>
            </span>
          ))}
        </div>
        <form onSubmit={add} className="flex gap-2 max-w-md">
          <Input type="email" value={draft} onChange={(e) => setDraft(e.target.value)} placeholder="name@primemediawireless.com" data-testid="notify-recipient-input" />
          <Button disabled={saving || !draft.trim()} className="bg-teal hover:bg-teal-dark text-white" data-testid="notify-recipient-add">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Plus className="w-4 h-4 mr-1" />Add</>}
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
